import React from 'react'

function AppDevelopmentSolutions() {
   return (
      <section className="container-fluid section_primary_bg">
         <div className="container text-center mb-4 innovation_comman blockchain_innovation">
            <h2 className="tech_title section_heading_title mb-2">
               Benzatine’s All-Inclusive Entertainment & Media App Development
               Solutions
            </h2>
            <p className="sub_body">
               At Benzatine, we specialize in building state-of-the-art travel
               applications and software solutions that enhance the overall
               travel experience while driving efficiency for businesses. Our
               expertise in travel app development enables us to create
               innovative, user-centric platforms tailored to meet the diverse
               needs of the travel industry. From seamless booking systems to
               smart itinerary planners, we empower your business with
               cutting-edge technology.
            </p>
         </div>

         <div className="container text-center">
            <div className="innovation_card_main blockchain_innovation_card_main industry_web_new">
               <div className="row g-4 industry-grid travel-tourism-wrap">
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img src="/assets/svg/industries/media/Vod.svg" alt="Health Icon" />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           VOD (Video-On-Demand) Systems
                        </h4>
                        <p className="industry-description">
                           Create scalable, high-performance VOD platforms with adaptive
                           streaming, personalized recommendations, and easy content
                           categorization to provide seamless user experiences on devices with
                           secure content management and monetization features for maximum
                           engagement and revenue generation.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/media/advance-video.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Advanced Video Editing Software
                        </h4>
                        <p className="industry-description">
                           Create advanced video editing software with AI-driven automation,
                           real-time rendering, multi-format export, and sophisticated editing
                           tools. Improve user experience with easy-to-use interfaces,
                           intelligent effects, and cloud storage integration for smooth
                           workflow and high-quality content creation.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img src="/assets/svg/industries/media/music.svg" alt="Logistics Icon" />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Music Streaming Platforms
                        </h4>
                        <p className="industry-description">
                           Build feature-rich music streaming applications with smart
                           suggestions, high-fidelity audio, hand-picked playlists, offline
                           listening, and instant multi-device synchronization. Increase user
                           interaction with AI-driven personalization, social sharing, and
                           revenue via subscriptions, ads, or premium content.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img src="/assets/svg/industries/media/photo.svg" alt="Ecommerce Icon" />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Photo Editing & Sharing Tools
                        </h4>
                        <p className="industry-description">
                           Build robust photo editing apps with AI-based filters, advanced
                           retouching, batch processing, and instant social sharing. Boost
                           creativity using customizable effects, cloud storage, and
                           cross-platform support for a seamless and intuitive experience.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img src="/assets/svg/industries/media/live.svg" alt="Real Estate Icon" />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Live Video Streaming Platforms
                        </h4>
                        <p className="industry-description">
                           Construct ultra-low latency, high-definition live streaming
                           solutions that are scalable, interactive chat enabled, and
                           multi-platform compatible. Ideal for webinars, live events, and
                           gaming, to provide smooth audience engagement through adaptive
                           streaming and resilient content delivery networks (CDNs).
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/media/digital-asset.svg"
                              alt="Real Estate Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Digital Asset Management Solutions
                        </h4>
                        <p className="industry-description">
                           Maximize media asset management with AI-tagged organization,
                           metadata, and secure access control. Simplify content distribution,
                           automate processes, and improve collaboration with cloud storage
                           solutions built for businesses, media agencies, and content
                           creators.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/media/content.svg"
                              alt="Real Estate Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Content Management Systems (CMS)
                        </h4>
                        <p className="industry-description">
                           Design easy-to-use CMS platforms for media-intense content,
                           facilitating effortless content creation, editing, and publishing.
                           Improve workflow productivity through smart UI, AI-driven
                           automation, secure architecture, and scalable infrastructure that
                           supports businesses of any size.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/media/digital-right.svg"
                              alt="Real Estate Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Digital Rights Management (DRM)
                        </h4>
                        <p className="industry-description">
                           Provide secure content protection through advanced DRM solutions,
                           defending digital assets from piracy and unauthorized sharing. Use
                           encryption, access management, and licensing capabilities to secure
                           intellectual property on streaming services and digital media
                           usages.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/media/podcast.svg"
                              alt="Gaming Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Podcast Hosting & Distribution
                        </h4>
                        <p className="industry-description">
                           Develop feature-rich podcast platforms with high-quality audio
                           streaming, audience analytics, multi-platform distribution, and
                           monetization options. Enable creators to engage listeners with
                           seamless episode management, personalized recommendations, and
                           interactive engagement features.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img src="/assets/svg/industries/media/movie.svg" alt="Media Icon" />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Movie Review & Rating Platforms
                        </h4>
                        <p className="industry-description">
                           Design user-generated content-based review and rating sites with
                           AI-powered recommendations, real-time content, and social sharing
                           features. Increase user participation through gamification,
                           discussion boards, and user-generated insights for an engaging
                           entertainment experience.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/media/advertising.svg"
                              alt="Social Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Advertising & Monetization Solutions
                        </h4>
                        <p className="industry-description">
                           The game generates maximum income when monetization strategies unite
                           through in-app advertisements as well as subscription packages and
                           pay-per-view features and sponsorships. The utilization of AI-ad
                           targeting and dynamic pricing with well-integrated payment gateways
                           ensures maximum audience interaction and profit achievement.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/media/broadcasting.svg"
                              alt="Travel Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Broadcasting & OTT Solutions
                        </h4>
                        <p className="industry-description">
                           Build scalable, high-performance broadcasting and OTT platforms
                           supporting multi-device streaming, adaptive bitrate delivery, cloud
                           storage, and strong analytics. Make content distribution smooth,
                           viewer experiences more enhanced, and infrastructure scalable for
                           media businesses, broadcasters, and content creators.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default AppDevelopmentSolutions
